import Immutable from 'immutable';
import {
  FLAG_GETTING_CIRCUITS,
  GET_CIRCUITS,
  CLEAR_CIRCUITS,
  FLAG_CIRCUIT_ACTIVITY,
  CLEAR_CIRCUIT,
  GET_CIRCUIT,
} from '../../../actions/types/route';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_CIRCUITS:
      return state.setIn(['all', 'loading'], payload);
    case GET_CIRCUITS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_CIRCUITS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_CIRCUIT_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_CIRCUIT:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_CIRCUIT:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
